import type {
  InvestmentActions,
  InvestmentState,
  InvestmentStateData,
} from "./types";

export const fetchInvestmentData = (): InvestmentActions => ({
  type: "FECTH_INVESTMENT_DATA",
});

export const fetchInvestementDataSuccess = (
  payload: InvestmentStateData[]
): InvestmentActions => ({
  type: "FETCH_INVESTEMENT_DATA_SUCCESS",
  payload,
});

export const fetchInvestmentDataFailed = (): InvestmentActions => ({
  type: "FETCH_INVESTEMENT_DATA_FAILED",
});
